


































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import settings from "@/config/tv/settings.json";

interface ISettingJSON {
  pcr_offset_in_ms: IModeType;
  room_number: IModeType;
  tv_name: IModeType;
  full_browser_start_page_url: IModeType;
  maximum_volume_level: IModeType;
  soft_ap_password: IModeType;
  alternative_lg_service_xml: IModeType;
  alternative_url: IModeType;
  installation_menu_password: IModeType;
}

interface IModeType {
  key: string;
  description: string;
  read_write: { read: boolean; write: boolean };
  example: string;
  offset_value: string;
}

interface ICommand {
  key: string;
  value: string;
  updatetime: string; //default: now
  date: Date;
  manager_id: string;
}

@Component({})
export default class InputCommand extends Vue {
  @Prop({ type: String, default: "command" }) type!: string;
  @Prop({ type: Array, default: () => [] }) tvs!: Array<string>;

  s: ISettingJSON = settings;
  value_format: number | string = "";
  invalid = false;
  canSend = false;

  get mode(): IModeType | null {
    if (this.type == "pcr_offset_in_ms") return this.s.pcr_offset_in_ms;
    if (this.type == "room_number") return this.s.room_number;
    if (this.type == "tv_name") return this.s.tv_name;
    if (this.type == "full_browser_start_page_url")
      return this.s.full_browser_start_page_url;
    if (this.type == "maximum_volume_level") return this.s.maximum_volume_level;
    if (this.type == "soft_ap_password") return this.s.soft_ap_password;
    if (this.type == "alternative_lg_service_xml")
      return this.s.alternative_lg_service_xml;
    if (this.type == "alternative_url") return this.s.alternative_url;
    if (this.type == "installation_menu_password")
      return this.s.installation_menu_password;
    return null;
  }

  get input_type(): string {
    if (
      this.type == "pcr_offset_in_ms" ||
      this.type == "maximum_volume_level" ||
      this.type == "installation_menu_password"
    )
      return "number";

    if (
      this.type == "room_number" ||
      this.type == "tv_name" ||
      this.type == "full_browser_start_page_url" ||
      this.type == "soft_ap_password" ||
      this.type == "alternative_lg_service_xml" ||
      this.type == "alternative_url"
    )
      return "text";
    return "text";
  }

  @Watch("tvs")
  updateCanSend(): void {
    if (this.type == "room_number" || this.type == "tv_name") {
      this.canSend = this.tvs.length != 1 ? false : true;
      return;
    }
    this.canSend = this.tvs.length ? true : false;
  }

  @Watch("value_format")
  invalidation(): void {
    if (!this.mode) return;
    if (
      this.type == "pcr_offset_in_ms" ||
      this.type == "maximum_volume_level"
    ) {
      if (Number.isNaN(Number(this.value_format))) this.invalid = true;
      else {
        const interval = this.mode.offset_value.split("~");
        if (
          (this.value_format as number) < parseInt(interval[0]) ||
          (this.value_format as number) > parseInt(interval[1])
        )
          this.invalid = true;
        else this.invalid = false;
      }
      return;
    }
    // string
    if (
      this.type == "room_number" ||
      this.type == "tv_name" ||
      this.type == "soft_ap_password"
    ) {
      this.invalid =
        String(this.value_format).length > parseInt(this.mode.offset_value)
          ? true
          : false;
      return;
    }

    if (this.type == "installation_menu_password") {
      if (Number.isNaN(Number(this.value_format))) this.invalid = true;
      else
        this.invalid =
          String(this.value_format).length > parseInt(this.mode.offset_value)
            ? true
            : false;
      return;
    }
  }

  onSuccess(): void {
    if (this.invalid) return;
    if (!this.mode || !this.value_format || !this.tvs.length) return;
    let data = this.value_format;
    if (this.type == "room_number" || this.type == "tv_name")
      data = "[TV]" + this.value_format;
    const command: ICommand = {
      key: this.mode.key,
      value: String(data),
      updatetime: "now",
      date: new Date(),
      manager_id: "",
    };
    this.value_format = "";
    this.$emit("sendComands", command);
  }
}
